

<template>
  <div>
    <div id="preview-wrapper">
      <preview :src="meta.url" @update="createImageObject"/>
    </div>
    <form
      id="drag-and-drop"
      action
      @submit.stop="uploadFile"
      ref="uploadFileDropBox"
      class="d-flex justify-content-center align-items-center"
    >
      <input
        id="fileInput"
        type="file"
        @change="selectFile"
        ref="uploadFileInput"
        style="display:none"
      >
      <div>
        <div class="text-center text-muted">Drag & Drop an Image</div>
        <b-button
          variant="primary"
          @click="$refs.uploadFileInput.click()"
        >Select an Image from your filesystem</b-button>
      </div>
      <!-- .form-group -->
    </form>

    <ImageValidate v-if="meta.valid" :meta="meta" :eid="eid" @cancel="cancel()"/>
  </div>
</template>

<script>
import ImageValidate from '@/components/upload/ImageValidate.vue'
import Preview from '@/components/upload/Preview.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  props: ['eid'],
  components: { ImageValidate, Preview },
  data() {
    return {
      meta: {
        file: null,
        url: null,
        width: null,
        height: null,
        valid: false,
        name: null
      },
      errorMsg: []
    }
  },
  filters: {
    // component uses global filters
  },
  computed: {
    testDragable: () => {
      const div = document.createElement('div')
      return (
        'draggable' in div ||
        ('ondragstart' in div &&
          'ondrop' in div &&
          'FormData' in window &&
          'FileReader' in window)
      )
    },
    ...mapState(['config']),
    ...mapGetters(['readableFileSize'])
  },
  methods: {
    createImageObject(width, height) {
      this.meta.height = height
      this.meta.width = width
      this.isValid()
    },
    createImage(file) {
      let reader = new FileReader()
      reader.onload = event => {
        this.meta.url = event.target.result
      }
      reader.readAsDataURL(file)
    },
    selectFile(event) {
      this.meta.file = event.target.files[0]
      this.meta.name = this.meta.file.name
      let fileInput = document.getElementById('fileInput')
      fileInput.value = ''
      return this.createImage(this.meta.file)
    },
    cancel() {
      this.meta.file = null
      this.meta.url = null
      this.meta.height = null
      this.meta.width = null
      this.meta.name = null
      this.meta.valid = false
    },
    isValid() {
      // File Size Test
      const title = 'There is a problem with your file'
      const requiredFormat = 'image/jpeg'
      var requiredWidth = this.config.photoDim.landscape.width
      var requiredHeight = this.config.photoDim.landscape.height
      const widthHeightFlash = `Your image must be greater than ${requiredWidth} pixels on the longest side and ${requiredHeight} on the shortest side`
      if (this.meta.width < this.meta.height) {
        requiredWidth = this.config.photoDim.portrait.width
        requiredHeight = this.config.photoDim.portrait.height
      } else if (this.meta.width == this.meta.height) {
        requiredWidth = this.config.photoDim.square.width
        requiredHeight = this.config.photoDim.square.height
      }
      // FILE SIZE
      try {
        if (this.meta.file.size > this.config.fileSize)
          throw 'File size is too big'
      } catch (error) {
        const notification = {
          title: title,
          type: 'error',
          message:
            'File is too big. The file size must be less than ' +
            this.readableFileSize(this.config.fileSize, 2)
        }
        this.$store.dispatch('notification/add', notification, { root: true })
        this.errorMsg.push(error)
      }
      // FILE SIZE
      try {
        if (this.meta.file.size < 134) throw 'File size is too small'
      } catch (error) {
        const notification = {
          title: title,
          type: 'error',
          message:
            'File is too small. The file size must be greater than 134 Bytes</span>'
        }
        this.$store.dispatch('notification/add', notification, { root: true })
        this.errorMsg.push(error)
      }
      // FILE FORMAT
      try {
        if (this.meta.file.type != requiredFormat) throw 'Incorrect file format'
      } catch (error) {
        const notification = {
          title: title,
          type: 'error',
          message:
            'You attempted to upload ' +
            this.meta.file.type +
            ' Sorry! We only accept JPGs'
        }
        this.$store.dispatch('notification/add', notification, { root: true })
        this.errorMsg.push(error)
      }

      try {
        if (this.meta.width < requiredWidth) throw 'Width is wrong'
      } catch (error) {
        const notification = {
          title: title,
          type: 'error',
          message:
            'Your image is ' +
            this.meta.width +
            ' pixels wide and ' +
            this.meta.height +
            ' pixels tall. ' +
            this.meta.width +
            ` pixel width is too small, this image's width must be greater than ` +
            requiredWidth +
            '. ' +
            widthHeightFlash
        }
        this.$store.dispatch('notification/add', notification, { root: true })
        this.errorMsg.push(error)
      }
      // IMAGE DIMENSIONS - HEIGHT
      try {
        if (this.meta.height < requiredHeight) throw 'Wrong height'
      } catch (error) {
        const notification = {
          title: title,
          type: 'error',
          message:
            'Your image is ' +
            this.meta.width +
            ' pixels wide and ' +
            this.meta.height +
            ' pixels tall. ' +
            this.meta.height +
            `pixel height is too short, this image's height must be greater than ` +
            requiredHeight +
            '. ' +
            widthHeightFlash
        }
        this.$store.dispatch('notification/add', notification, { root: true })
        this.errorMsg.push(error)
      }

      if (this.errorMsg.length > 0) {
        // this.showModal()
        this.errorMsg = []
        this.cancel()
        return (this.meta.valid = false)
      } else {
        return (this.meta.valid = true)
      }
    }
  },
  mounted() {
    // DRAG AND DROP
    if (this.testDragable) {
      // computed prop
      // console.log('drag')
      const dragEvents = [
        'drag',
        'dragstart',
        'dragend',
        'dragover',
        'dragenter',
        'dragleave',
        'drop'
      ]
      dragEvents.forEach(dragEvent => {
        this.$refs.uploadFileDropBox.addEventListener(
          dragEvent,
          e => {
            e.preventDefault(dragEvent)
            e.stopPropagation()
          },
          false
        )
      })
      this.$refs.uploadFileDropBox.addEventListener('drop', event => {
        this.meta.file = event.dataTransfer.files[0]
        return this.createImage(event.dataTransfer.files[0])
      })
    } // end DRAG AND DROP
  }
}
</script>

<style scoped lang="scss">
#drag-and-drop {
  background-color: white;
  height: 200px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
#preview-wrapper {
  width: 1px;
  height: 1px;
  overflow: hidden;
}
</style>
